"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var SPACING = 8;
var JUSTIFY_CONTENT = {
    center: 'center',
    left: 'flex-start',
    right: 'flex-end',
};
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: ", ";\n  text-align: ", ";\n  margin: -", "px;\n\n  > * {\n    margin: ", "px;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: ", ";\n  text-align: ", ";\n  margin: -", "px;\n\n  > * {\n    margin: ", "px;\n  }\n"])), function (_a) {
    var _b = _a.$align, $align = _b === void 0 ? 'left' : _b;
    return JUSTIFY_CONTENT[$align];
}, function (_a) {
    var _b = _a.$align, $align = _b === void 0 ? 'left' : _b;
    return $align;
}, SPACING / 2, SPACING / 2);
var templateObject_1;
